(function(){
  var pd=document.querySelector('[data-product]');if(!pd)return;
  var add=document.getElementById('pd-add'),bar=document.getElementById('stickyBuy'),sbP=document.getElementById('sb-price'),sbS=document.getElementById('sb-size'),ship=pd.querySelector('.ship-line');
  function sync(){
    var b=pd.querySelector('.info .sizes [aria-pressed="true"]'),q=+(document.getElementById('pd-q')||{}).textContent||1;
    if(!b)return;var unit=+b.dataset.price,tot=unit*q;
    if(sbP)sbP.textContent=Math.round(unit/100).toLocaleString('en-PK');
    if(sbS)sbS.textContent=(b.querySelector('b')||b).textContent;
    if(ship)ship.innerHTML=(tot>=500000?'<b>Free delivery</b> on this order':'Delivery Rs 250 · <b>Free over Rs 5,000</b>')+' · Cash on Delivery';
  }
  pd.addEventListener('click',function(){setTimeout(sync,0)});
  var sb=document.getElementById('sb-add');if(sb&&add)sb.addEventListener('click',function(){add.click()});
  if(bar&&add&&'IntersectionObserver' in window){new IntersectionObserver(function(e){var on=!e[0].isIntersecting&&e[0].boundingClientRect.top<0;bar.classList.toggle('on',on);bar.setAttribute('aria-hidden',!on)}).observe(add)}
  sync();
})();
